module.exports = __webpack_public_path__ + "img/camperdrive.7e0c6071.jpg";